
import { useEffect, useRef } from "react";
import { primeEffects } from "@/utils/effects";

export const useDemoEffects = () => {
  const hasInitialized = useRef(false);
  
  // Initialize effects on first render and user interaction
  useEffect(() => {
    if (hasInitialized.current) return;
    
    // Prime the effects on load
    primeEffects();
    
    // Add interaction listeners to prime effects on any user interaction
    const initOnInteraction = () => {
      primeEffects();
      hasInitialized.current = true;
    };
    
    // Prime on document interaction to ensure it gets called
    ['click', 'touchstart', 'pointerdown'].forEach(eventType => {
      document.addEventListener(eventType, initOnInteraction, { once: true });
    });
    
    return () => {
      // Cleanup
      ['click', 'touchstart', 'pointerdown'].forEach(eventType => {
        document.removeEventListener(eventType, initOnInteraction);
      });
    };
  }, []);

  return {
    primeEffects,
  };
};
